<template>
  <b-modal id="applicationFeePerUserModal" size="lg" @shown="setFormModal" @hidden="resetFormModal">
    <template v-slot:modal-title>
      <h4 style="margin-bottom: 0px;">
        {{ action === 'edit' ? 'Update' : 'Add' }}
        {{ feeType === 'ticket' ? 'Ticket' : 'Gift Card' }} Fee Configuration for User
      </h4>
      <small v-if="action === 'edit'">
        {{ userEmail }}
      </small>
    </template>

    <form>
      <b-alert :show="action === 'create'">
        Should provide a registrered user email to add specific fee
      </b-alert>

      <ShowErrors
        :errorMessages="errorMessages"
      />

      <div class="form-group" v-if="action === 'create'">
        <label for="userEmail" class="required">User Email</label>
        <b-input class="form-control form-control-lg col-lg-12"
          data-vv-as="User email" v-model="user.email"
          name="userEmail" v-validate="'required|email'">
        </b-input>
        <span v-show="errors.has('userEmail')" class="input-error">
          {{ errors.first('userEmail') }}
        </span>
      </div>

      <b-row>
        <b-col>
          <div class="form-group">
            <label for="feeBaseCost" class="required">Fee Base Cost</label>
            <CurrencyInput
              v-model="userSettings.FEE_BASE_COST.value"
              data-vv-as="Fee base cost"
              class="form-control form-control-lg col-lg-8"
              :name="'feeBaseCost'"
              :key="'feeBaseCost'"
              v-validate="'required'"/>
            <span v-show="errors.has('feeBaseCost')" class="input-error">
              {{ errors.first('feeBaseCost') }}
            </span>
          </div>
        </b-col>

        <b-col>
          <div class="form-group">
            <label for="feePercentage" class="required">Fee Percentage</label>
            <b-input-group append="%" class="mb-2 mr-sm-2 mb-sm-0">
              <b-input class="form-control form-control-lg col-lg-4"
                data-vv-as="Fee percentage" v-model="userSettings.FEE_PERCENTAGE.value"
                name="feePercentage" v-validate="'required|min:1|min_value:0|max:5|max_value:100|decimal:2'">
              </b-input>
            </b-input-group>
            <span v-show="errors.has('feePercentage')" class="input-error">
              {{ errors.first('feePercentage') }}
            </span>
          </div>
        </b-col>
      </b-row>
    </form>

    <template slot="modal-footer" slot-scope="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="primary" @click="validate()">
        {{ action === 'edit' ? 'Update' : 'Save'}}
      </b-button>
    </template>

  </b-modal>
</template>

<script>
import ShowErrors from '../../../common/ShowErrors'
const axiosConst = require('axios').default

export default {
  name: 'TicketFeePerUserForm',
  components: {
    ShowErrors
  },
  props: {
    feeType: {
      required: true,
      type: String
    },
    action: {
      required: true,
      type: String
    },
    userTicketSettingsList: {
      required: true,
      type: Object,
      default: Object.new
    },
    userGiftCardSettingsList: {
      required: true,
      type: Object,
      default: Object.new
    },
    userFeeSettings: {
      required: false,
      type: Array
    },
    userEmail: {
      required: false,
      type: String
    }
  },
  data: function () {
    return {
      errorMessages: [],
      user: {
        email: null
      },
      userSettings: {
        FEE_BASE_COST: { value: undefined },
        FEE_PERCENTAGE: { value: undefined }
      }
    }
  },
  methods: {
    validate () {
      let self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.saveUserSettings()
        }
      })
    },
    saveUserSettings () {
      let self = this
      let httpRequests = []
      let loader = this.$loading.show()

      Object.keys(this.userSettings).sort().forEach((userSettingKey) => {
        let userSettingValue = self.userSettings[userSettingKey].value
        let userSettingId = self.userSettings[userSettingKey].id
        let userSettingName = this.feeType === 'ticket'
          ? `TICKET_${userSettingKey}` : `GIFT_CARD_${userSettingKey}`

        let userSetting = {
          name: userSettingName,
          value: userSettingValue
        }

        if (isNaN(userSettingId)) {
          httpRequests.push(self.$http.post('/user_settings', { user_setting: userSetting, user_email: self.user.email }))
        } else {
          httpRequests.push(self.$http.put('/user_settings/' + userSettingId, { user_setting: userSetting }))
        }
      })

      axiosConst.all(httpRequests).then((responses) => {
        self.$bvModal.hide('applicationFeePerUserModal')

        self.$swal({
          title: 'Custom fee created!',
          type: 'success'
        })

        self.$emit('reloadUserSettings')
      }).catch((error) => {
        self.errorMessages = []
        if (error) {
          self.$swal({
            title: 'Error creating custom fee!',
            type: 'error'
          })

          let errorMsgs = error.response.data.message || error.response.data.error
          self.errorMessages.push(errorMsgs)
        }
      }).finally(() => {
        loader.hide()
      })
    },
    setFormModal () {
      let self = this
      this.user['email'] = this.userEmail

      if (this.action === 'edit') {
        this.userFeeSettings.forEach((userSetting, index) => {
          let settingKey = userSetting.name.match(/FEE_BASE_COST/) ? 'FEE_BASE_COST' : 'FEE_PERCENTAGE'

          self.userSettings[settingKey]['id'] = userSetting.id
          self.userSettings[settingKey]['value'] = userSetting.value
        })
      }
    },
    resetFormModal () {
      this.user['email'] = null
      this.userSettings['FEE_BASE_COST'] = { value: 0 }
      this.userSettings['FEE_PERCENTAGE'] = { value: 0 }
    }
  }
}
</script>
